import { memo } from "react";
import { useTranslation } from "react-i18next";
import { ReloadIcon } from "@/icons";
import { Tooltip } from "@/interface/ui/Tooltip";
import styles from "../FullscreenPresentationLayout.module.scss";

type ReloadControlProps = {
    onReload: () => void;
};

export const ReloadControl = memo(({ onReload }: ReloadControlProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.reloadControl}>
            <Tooltip content={t("presentation.reload")}>
                <button className={styles.navigationButton} type="button" onClick={onReload}>
                    <ReloadIcon />
                </button>
            </Tooltip>
        </div>
    );
});
